import { useEffect, useState } from "react";
import Select from "react-select";
import { generateYears, getFromDecreaptLocalStorage, seasonValues, titleCase } from "../../utilFunctions";
import { fieldSurveyStatus, pmfby, REGEX, VENDOR_MANAGER } from "../../consts";
import { actionDropdownList, fieldKeys, getSurveyorList } from "./helper";
import DatePicker from "react-datepicker";
import { fetchDistricts, fetchMandals, fetchStates, fetchVillages } from "../apiHelper";
import { getVendorsList } from "../vendorMaster/helper";

const Filters = ({ setValue, fieldValues, productNames, handleSearch, handleReset, setData }) => {
    const roleDataCookie = getFromDecreaptLocalStorage("roleData")
    const yearsFrom2023 = generateYears(2023)?.reverse();
    const [statesList, setStatesList] = useState([]);
    const [districtList, setDistrictList] = useState([]);
    const [mandalList, setMandalList] = useState([]);
    const [villageList, setVillageList] = useState([]);
    const [vendorsList, setVendorsList] = useState([]);
    const [surveyorsList, setSurveyorsList] = useState([])

    const getStatesList = async (productID) => {
        const fetchedStates = await fetchStates(productID);
        setStatesList(fetchedStates);
    };
    const getDistrictList = async (state) => {
        const fetchedDistricts = await fetchDistricts(state, fieldValues[fieldKeys.product]?.value);
        setDistrictList(fetchedDistricts);
    };

    const getMandalList = async (district, state) => {
        if (district && state) {
            const fetchedMandals = await fetchMandals(district, state, fieldValues[fieldKeys.product]?.value);
            setMandalList(fetchedMandals);
        }
    };

    const getVillageList = async (mandal, district, state) => {
        if (mandal && district && state) {
            const fetchedVillages = await fetchVillages(mandal, district, state,fieldValues[fieldKeys.product]?.value);
            setVillageList(fetchedVillages);
        }
    }

    
    useEffect(() => {
        getStatesList();
        if(roleDataCookie?.roleName!== VENDOR_MANAGER ) {
            getVendorsList(setVendorsList, true);
        } else{
            //get the vendorId from localstorage
            const vendorManagerDetails = getFromDecreaptLocalStorage("vendorManagerDetails");
            if(vendorManagerDetails.vendorId) {
                getSurveyorList(vendorManagerDetails.vendorId, setSurveyorsList)
            }

        }
    }, []);

    const handleIntimationDateRange = (date, key) => {
        if (date) {
            const year = date.getFullYear();
            const month = (date.getMonth() + 1).toString().padStart(2, "0");
            const dat1 = date.getDate().toString().padStart(2, "0");
            setValue( key, `${year}-${month}-${dat1}` );
        }else{
            setValue( key, null )
        }
    };

    const surveyStatusDropDownList =[
        {value: fieldSurveyStatus.ASSIGNED, label: titleCase(fieldSurveyStatus.ASSIGNED)},
        {value: fieldSurveyStatus.WORK_IN_PROGRESS, label: titleCase(fieldSurveyStatus.WORK_IN_PROGRESS)},
        {value: fieldSurveyStatus.SAVED_AS_DRAFT, label: titleCase(fieldSurveyStatus.SAVED_AS_DRAFT)},
        {value: fieldSurveyStatus.COMPLETED, label: titleCase(fieldSurveyStatus.COMPLETED)},
        {value: fieldSurveyStatus.IN_COMPLETE, label: titleCase(fieldSurveyStatus.IN_COMPLETE)}
    ]

    return (
        <div
            className="border rounded pb-3"
            style={{ zIndex: 2, position: "relative" }}
        >
            <div className="row">
                <div className="col d-md-flex align-items-center justify-content-around mt-3">
                    <div className="col form-group ms-2">
                        <label htmlFor="seasonName">Season</label>
                        <Select
                            id="seasonName"
                            options={seasonValues || []}
                            classNamePrefix="bg-gray"
                            placeholder="Select Season"
                            onInputChange={(inputValue) => {
                                const cleanedValue = inputValue.replace(
                                    REGEX.ALPHABET_REGEX,
                                    ""
                                );
                                return cleanedValue;
                            }}
                            value={
                                fieldValues[fieldKeys.season]
                                    ? seasonValues.find(
                                        (seasonName) =>
                                            seasonName.value === fieldValues[fieldKeys.season]
                                    )
                                    : null
                            }
                            onChange={(data) => {
                                setValue(fieldKeys.season, data?.value ?? "");
                            }}
                            isClearable
                        />
                    </div>
                    <div className="col form-group ms-2">
                        <label htmlFor="yearFrom2023">Year</label>
                        <Select
                            id="yearFrom2023"
                            options={yearsFrom2023}
                            onInputChange={(inputValue) => {
                                const cleanedValue = inputValue.replace(
                                    REGEX.FOUR_DIGIT_NUMBER_REGEX,
                                    ""
                                );
                                return cleanedValue;
                            }}
                            classNamePrefix="bg-gray"
                            placeholder="Select Year"
                            value={
                                fieldValues[fieldKeys.year]
                                    ? {
                                        label: fieldValues[fieldKeys.year],
                                        value: fieldValues[fieldKeys.year],
                                    }
                                    : null
                            }
                            onChange={(data) => {
                                setValue(fieldKeys.year, data?.value ?? "");
                            }}
                            isClearable
                        />
                    </div>
                    <div className="col form-group ms-2">
                        <label>Product</label>
                        <Select
                            id="exampleInputPassword1"
                            options={productNames}
                            onInputChange={(inputValue) => {
                                const cleanedValue = inputValue.replace(
                                    REGEX.ALPHABET_REGEX,
                                    ""
                                );
                                return cleanedValue;
                            }}
                            classNamePrefix="bg-gray"
                            placeholder="Select Product"
                            value={
                                fieldValues[fieldKeys.product]?.label
                                    ? fieldValues[fieldKeys.product]
                                    : null
                            }
                            onChange={(data) => {
                                const  isCurrentOrPreviousPMFBY = fieldValues[fieldKeys.product]?.value === pmfby || data?.value === pmfby
                                setValue(fieldKeys.product, data ?? null);
                                if(isCurrentOrPreviousPMFBY) {
                                    getStatesList(data?.value ?? null);
                                    setValue(fieldKeys.state,  "");
                                    setValue(fieldKeys.district,"");
                                    setValue(fieldKeys.mandal,  "");
                                    setValue(fieldKeys.village,  "");
                                }
                                if(data?.value !== pmfby) {
                                    setValue(fieldKeys.downloadStatus, null)
                                }
                            }}
                            isClearable
                        />
                    </div>
                    <div className="col form-group ms-2">
                        <label for="exampleInputPassword1">Policy / Application No.</label>
                        <input
                            type="text"
                            className="form-control bg-gray"
                            placeholder="Enter Policy / Application No"
                            onChange={(e) => {
                                const value = e.target.value.replace(
                                    REGEX.ALPHANUMERIC,
                                    ""
                                );
                                setValue(fieldKeys.policyNumber, value)
                            }}
                            value={fieldValues[fieldKeys.policyNumber]}
                        />
                    </div>
                    
                </div>
            </div>
            <div className="row">
                <div className="col d-md-flex align-items-center justify-content-around mt-3">
                    <div className="col form-group ms-2">
                        <label htmlFor="selectState">State</label>
                        <Select
                            id="selectState"
                            options={statesList || []}
                            classNamePrefix="bg-gray"
                            placeholder="Select State"
                            value={
                                fieldValues[fieldKeys.state]
                                    ? {
                                        label: fieldValues[fieldKeys.state],
                                        value: fieldValues[fieldKeys.state],
                                    }
                                    : null
                            }
                            onChange={(data) => {
                                if (data) {
                                    getDistrictList(data?.value);
                                }
                                setValue(fieldKeys.state, data?.value ?? "");
                                setValue(fieldKeys.district, "");
                                setValue(fieldKeys.mandal, "");
                                setValue(fieldKeys.village, "");
                            }}
                            isClearable
                        />
                    </div>
                    <div className="col form-group ms-2">
                        <label htmlFor="selectDistrict">District</label>
                        <Select
                            id="selectDistrict"
                            options={districtList || []}
                            classNamePrefix="bg-gray"
                            placeholder="Select District"
                            isDisabled={!fieldValues[fieldKeys.state]}
                            value={
                                fieldValues[fieldKeys.district]
                                    ? {
                                        label: fieldValues[fieldKeys.district],
                                        value: fieldValues[fieldKeys.district],
                                    }
                                    : null
                            }
                            onChange={(data) => {
                                if (data) {
                                    getMandalList(data?.value, fieldValues[fieldKeys.state]);
                                }
                                setValue(fieldKeys.district, data?.value ?? "");
                                setValue(fieldKeys.mandal, "");
                                setValue(fieldKeys.village, "");
                            }}
                            isClearable
                        />
                    </div>
                    <div className="col form-group ms-2">
                        <label htmlFor="selectMandal">Mandal</label>
                        <Select
                            id="selectMandal"
                            options={mandalList || []}
                            classNamePrefix="bg-gray"
                            placeholder="Select Mandal"
                            isDisabled={!fieldValues[fieldKeys.district]}
                            value={
                                fieldValues[fieldKeys.mandal]
                                    ? {
                                        label: fieldValues[fieldKeys.mandal],
                                        value: fieldValues[fieldKeys.mandal],
                                    }
                                    : null
                            }
                            onChange={(data) => {
                                if (data) {
                                    getVillageList(data?.value, fieldValues[fieldKeys.district], fieldValues[fieldKeys.state])
                                }
                                setValue(fieldKeys.mandal, data?.value ?? "");
                                setValue(fieldKeys.village, "");
                            }}
                            isClearable
                        />
                    </div>
                    <div className="col form-group ms-2">
                        <label htmlFor="selectMandal">Village</label>
                        <Select
                            id="selectMandal"
                            options={villageList || []}
                            classNamePrefix="bg-gray"
                            placeholder="Select Mandal"
                            isDisabled={!fieldValues[fieldKeys.mandal]}
                            value={
                                fieldValues[fieldKeys.village]
                                    ? {
                                        label: fieldValues[fieldKeys.village],
                                        value: fieldValues[fieldKeys.village],
                                    }
                                    : null
                            }
                            onChange={(data) => {
                                setValue(fieldKeys.village, data?.value ?? "");
                            }}
                            isClearable
                        />
                    </div>
                    
                </div>
            </div>
            <div className="row">
                <div className="col d-md-flex align-items-center justify-content-around mt-3">
                    <div className="col form-group ms-2">
                        <label for="exampleInputPassword1">Farmer ID</label>
                        <input
                            type="text"
                            className="form-control bg-gray"
                            placeholder="Enter Farmer ID"
                            onChange={(e) => {
                                const value = e.target.value.replace(
                                    REGEX.ALPHANUMERIC,
                                    ""
                                );
                                setValue(fieldKeys.farmerId, value)
                            }}
                            value={fieldValues[fieldKeys.farmerId]}
                        />
                    </div>
                    <div className="col form-group ms-2">
                        <label for="exampleInputPassword1">Farmer Name</label>
                        <input
                            type="text"
                            className="form-control bg-gray"
                            placeholder="Enter Farmer Name"
                            onChange={(e) => {
                                setValue(fieldKeys.farmerName, e.target.value)
                            }}
                            value={fieldValues[fieldKeys.farmerName]}
                        />
                    </div>
                   
                    <div className="col form-group ms-2">
                        <label for="exampleInputPassword1">Survey ID</label>
                        <input
                            type="text"
                            className="form-control bg-gray"
                            placeholder="Enter Survey ID"
                            onChange={(e) => {
                                setValue(fieldKeys.surveyId, e.target.value)
                            }}
                            value={fieldValues[fieldKeys.surveyId]}
                        />
                    </div>
                    <div className="col form-group ms-2">
                        <label htmlFor="selectMandal">Survey Status</label>
                        <Select
                            id="selectMandal"
                            options={surveyStatusDropDownList}
                            classNamePrefix="bg-gray"
                            placeholder="Select Survey Status"
                            value={
                                fieldValues[fieldKeys.surveyStatus]
                                    ? fieldValues[fieldKeys.surveyStatus]
                                    : null
                            }
                            onChange={(data) => {
                                setValue(fieldKeys.surveyStatus, data || "");
                            }}
                            isClearable
                        />
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col d-md-flex align-items-center justify-content-around mt-3">
                    {roleDataCookie?.roleName && roleDataCookie?.roleName !== VENDOR_MANAGER && (
                        <div className="col form-group ms-2">
                            <label for="exampleInputPassword2">Vendor Name</label>
                            <Select
                                options={vendorsList}
                                onInputChange={(inputValue) => {
                                    const cleanedValue = inputValue.replace(
                                        REGEX.ALPHANUMERIC,
                                        ""
                                    );
                                    return cleanedValue;
                                }}
                                classNamePrefix="bg-gray"
                                placeholder="Select Vendor Name"
                                value={
                                    fieldValues[fieldKeys.vendorName]
                                        ? {
                                            label: titleCase(fieldValues[fieldKeys.vendorName]?.label),
                                            value: fieldValues[fieldKeys.vendorName]?.value,
                                            id: fieldValues[fieldKeys.vendorName]?.id,
                                            vendorName: fieldValues[fieldKeys.vendorName]?.vendorName
                                        }
                                        : null
                                }
                                onChange={(data) => {
                                    setValue(fieldKeys.vendorName, data ?? null);
                                    setValue(fieldKeys.surveyorName, null);
                                    setSurveyorsList([]);
                                    if(data) {
                                        getSurveyorList(data?.id,setSurveyorsList)
                                    }
                                }}
                                isClearable={true}
                            />
                        </div>
                    )}
                    <div className="col form-group ms-2">
                        <label for="exampleInputPassword2">Surveyor Name</label>
                        <Select
                            options={surveyorsList}
                            onInputChange={(inputValue) => {
                                const cleanedValue = inputValue.replace(
                                    REGEX.ALPHANUMERIC,
                                    ""
                                );
                                return cleanedValue;
                            }}
                            classNamePrefix="bg-gray"
                            placeholder="Select Surveyor Name"
                            value={
                                fieldValues[fieldKeys.surveyorName]
                                    ? {
                                        label: titleCase(fieldValues[fieldKeys.surveyorName]),
                                        value: fieldValues[fieldKeys.surveyorName],
                                    }
                                    : null
                            }
                            onChange={(data) => {
                                setValue(fieldKeys.surveyorName, data?.value ?? "");
                            }}
                            isDisabled={roleDataCookie?.roleName && roleDataCookie?.roleName !== VENDOR_MANAGER && !fieldValues[fieldKeys.vendorName]}
                            isClearable={true}
                        />
                    </div>
                    <div className="col form-group ms-2">
                        <label for="exampleInputPassword2">Survey Initiated Date</label>
                        <div className="d-md-flex intimation-date">
                            <div className="from-date">
                                <DatePicker
                                    className="form-control bg-gray"
                                    selected={
                                        fieldValues[fieldKeys.startDate] && fieldValues[fieldKeys.startDate]
                                    }
                                    dateFormat="dd-MM-yy"
                                    placeholderText="From date"
                                    maxDate={
                                        fieldValues[fieldKeys.endDate]
                                            ? new Date(fieldValues[fieldKeys.endDate])
                                            : new Date()
                                    }
                                    onChange={(date) =>
                                        handleIntimationDateRange(date, fieldKeys.startDate)
                                    }
                                    onKeyDown={(e) => e.preventDefault()}
                                    showYearDropdown
                                    showMonthDropdown
                                    scrollableYearDropdown
                                    yearDropdownItemNumber={1000}
                                />
                            </div>
                            <div className="to-date">
                                <DatePicker
                                    className="form-control bg-gray"
                                    selected={
                                        fieldValues[fieldKeys.endDate] && fieldValues[fieldKeys.endDate]
                                    }
                                    dateFormat="dd-MM-yy"
                                    placeholderText="To date"
                                    minDate={new Date(fieldValues[fieldKeys.startDate])}
                                    maxDate={new Date()}
                                    onChange={(date) =>
                                        handleIntimationDateRange(date, fieldKeys.endDate)
                                    }
                                    onKeyDown={(e) => e.preventDefault()}
                                    showYearDropdown
                                    showMonthDropdown
                                    scrollableYearDropdown
                                    yearDropdownItemNumber={1000}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col form-group ms-2">
                        <label for="exampleInputPassword2">Action</label>
                         {/* <OverlayTrigger
                          placement="top"
                          overlay={<Tooltip id="tooltip-top">This filter applicable only for PMFBY product</Tooltip>}
                        >
                          <i className="fa fa-info-circle ms-3" />
                        </OverlayTrigger> */}
                        <Select
                            options={actionDropdownList}
                            classNamePrefix="bg-gray"
                            placeholder="Select Action"
                            value={
                                fieldValues[fieldKeys.downloadStatus]
                                    ?  fieldValues[fieldKeys.downloadStatus]
                                    : null
                            }
                            onChange={(data) => {
                                setValue(fieldKeys.downloadStatus, data ?? null);
                            }}
                            isDisabled={!(fieldValues[fieldKeys.product]?.value === pmfby)}
                            isClearable={true}
                        />
                    </div>
                    {roleDataCookie?.roleName && roleDataCookie?.roleName === VENDOR_MANAGER && (
                        <div className="col form-group ms-2"></div>)}
                </div>
            </div>

            <div className="row">
                <div className="col-md-12 d-flex align-items-end justify-content-start">
                    <div className="form-group">
                        <button
                            className="btn btn-success m-3 mb-0 px-4 mt-4"
                            onClick={() => {
                                setData(null)
                                handleSearch(0,10);
                            }}
                        >
                            Search
                        </button>
                        <button
                            className="btn btn-outline-success m-3 mb-0 px-4 mt-4"
                            onClick={handleReset}
                        >
                            Reset
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Filters;
